/**
 * Vendor Banner Component
 * Handles smooth scrolling to brand media section when "Learn More" is clicked
 */
(() => {
  'use strict';
  
  // Constants
  const SELECTORS = {
    findMoreButton: '.js-vendor-banner__find-more',
    brandMedia: '.js-brand-media',
    stickyHeader: 'sticky-header'
  };
  
  const SCROLL_OPTIONS = {
    behavior: 'smooth',
    block: 'start'
  };
  
  // Cache DOM elements
  const elements = {
    findMoreButton: document.querySelector(SELECTORS.findMoreButton),
    brandMedia: document.querySelector(SELECTORS.brandMedia),
    stickyHeader: document.querySelector(SELECTORS.stickyHeader)
  };
  
  // Early return if required elements don't exist
  if (!elements.findMoreButton || !elements.brandMedia) {
    if (elements.findMoreButton) {
      elements.findMoreButton.classList.add('hidden');
    }
    return;
  }
  
  /**
   * Calculate scroll position accounting for sticky header
   * @returns {number} Y position to scroll to
   */
  const calculateScrollPosition = () => {
    const headerHeight = elements.stickyHeader?.offsetHeight || 0;
    const brandMediaRect = elements.brandMedia.getBoundingClientRect();
    return brandMediaRect.top + window.scrollY - headerHeight;
  };
  
  /**
   * Handle smooth scroll to brand media section
   * @param {Event} event - Click event
   */
  const handleScrollToBrandMedia = (event) => {
    event.preventDefault();
    
    try {
      const scrollPosition = calculateScrollPosition();
      
      // Use native smooth scrolling with fallback
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: scrollPosition,
          ...SCROLL_OPTIONS
        });
      } else {
        // Fallback for browsers without smooth scroll support
        window.scrollTo(0, scrollPosition);
      }
    } catch (error) {
      console.error('Error scrolling to brand media:', error);
      // Fallback to basic scroll
      elements.brandMedia.scrollIntoView();
    }
  };
  
  // Attach event listener
  elements.findMoreButton.addEventListener('click', handleScrollToBrandMedia, { passive: false });
  
  // Optional: Add keyboard support for accessibility
  elements.findMoreButton.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleScrollToBrandMedia(event);
    }
  });
})();
